import { ILookup, IPaginationResponse } from '../../../../core';

const systemRolesResponse: IPaginationResponse<ILookup<string>> = {
  items: [
    {
      id: '7bd3e96d-0944-41d4-8e76-586a13542275',
      englishName: 'customer',
    },
    {
      id: '7bd3e96d-0944-41d4-8e76-586a13542275',
      englishName: 'customer',
    }
  ],
  paginationMetadata: {
    totalItemCount: 11706,
    numberOfPages: 1171,
    pageSize: 10,
    order: 'Ascending',
    page: 1,
    hasNext: true,
    hasPrevious: false
  }
};

export const systemRolesData = {
  systemRolesResponse
};
